<template>
<div>
    <Breadcrumbs main="HR" submain="Payroll" title="Payroll Sheet" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" gross_salary="submit" v-b-modal.modal-generate-payroll-sheet style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Generate Payroll Sheet</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-wrap" style="gap: 20px;">
                                    <b-input-group class="datatable-btn" style="width: 340px;">
                                        <b-form-input v-model="filter" placeholder="Search..."></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!payrollLoading && !payrollError">
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :per-page="perPage" >
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    
                                      
                                    <template #cell(generated_by)="data">
                                      
                                                {{ data.item?.generated_by?.full_name }}
                                       
                                     
                                    </template>

                                    <template #cell(month)="data">
                                          <router-link :to="`/hr/payroll/payroll-sheet/${data.item.id}`" class="link-style" v-if="data.item?.month">
                                            <p  class="link-style">{{ getMonthName(data.item?.month) }}<span v-if="data.item?.year">, {{ data.item.year }}</span></p>
                                          </router-link>
                                        
                                    </template>

                                    <template #cell(status)="data">
                                        <b-badge :variant="getStatusVariant(data.item?.status)" v-if="data.item?.status" v-b-tooltip.hover title="Finalise payroll sheet" v-b-modal.modal-finalise-payroll-sheet @click="finalisePayrollSheet(data.item.id)">
                                            {{ data.item.status }}
                                        </b-badge>
                                    </template>
                                    <template #cell(action)="data">
                                        <div class="d-flex flex-row" style="gap:6px">
                                        
                                     <!-- <feather
                                            type="plus-circle"
                                            size="22px"
                                            style="color: #007bff; cursor: pointer;"
                                            v-b-tooltip.hover
                                            v-b-modal.modal-disbursement-create
                                            title="Create Disbursement"
                                            @click="createDisburse(data.item)"
                                        >
                                    </feather> -->
                                        <router-link
                                            :to="`/hr/payroll/disbursement-sheet/${data.item.id}`"
                                            v-b-tooltip.hover
                                            title="View Disbursement"
                                        >
                                            <feather
                                                type="eye"
                                                size="22px"
                                                style="color: #FF595D; cursor: pointer;"
                                            ></feather>
                                        </router-link>
                                        </div>
                                            
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0"> 
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Payroll sheet finalise Modal -->
    <b-modal id="modal-finalise-payroll-sheet" centered hide-header @ok="handleFinaliseOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to finalise this payroll sheet?</div>
    </b-modal>

    <!-- Payroll sheet generate Modal -->
    <b-modal id="modal-generate-payroll-sheet" centered hide-header @ok="handleGeneratePayrollSheet">
        <div class="mt-2 mb-3">
            <b-form-group label="Month" label-for="generate-month">
                <b-form-select id="generate-month" v-model="generate_month" :options="monthOptions" required></b-form-select>
            </b-form-group>
            <b-form-group label="Year" label-for="generate-year">
                <b-form-input id="generate-year" v-model="generate_year" type="number" min="1900" max="2099" placeholder="Enter year" required></b-form-input>
            </b-form-group>
        </div>
    </b-modal>
    <!-- Disburse Create -->

    <b-modal id="modal-disbursement-create" title="Create Disbursement" centered  @ok="handleDisbursement">
        <form ref="form" @submit.stop.prevent="handleDisbursementSubmit">
            <div class="mt-2 mb-3">
                <b-form-group label="Title" label-for="title">
                    <b-form-input id="notes" v-model="disbursement.title" type="text" placeholder="Enter title" required></b-form-input>
                </b-form-group>
                <b-form-group label="Notes" label-for="notes">
                    <b-form-input id="notes" v-model="disbursement.notes" type="text" placeholder="Enter notes"></b-form-input>
                </b-form-group>
        </div>
        </form>
        
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { computed } from 'vue';

export default {
    data() {
        return {
            filter: null,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'month',
                    label: 'Month',
                    sortable: false
                },
                {
                    key: 'generated_by',
                    label: 'Generated By',
                    sortable: true
                },
                {
                    key: 'total_employees',
                    label: 'Total Employees',
                    sortable: true
                },
                {
                    key: 'total_disbursed',
                    label: 'Total Disbursed',
                    sortable: true
                },
                {
                    key: 'total_net_pay',
                    label: 'Total Net Pay',
                    sortable: true
                },
               
                {
                    key: 'status',
                    label: 'Status',
                    sortable: false
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            finalise_id: null,
            initialLoad: true,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            generate_month: null,
            generate_year: null,
            monthOptions: [
                { value: 1, text: 'January' },
                { value: 2, text: 'February' },
                { value: 3, text: 'March' },
                { value: 4, text: 'April' },
                { value: 5, text: 'May' },
                { value: 6, text: 'June' },
                { value: 7, text: 'July' },
                { value: 8, text: 'August' },
                { value: 9, text: 'September' },
                { value: 10, text: 'October' },
                { value: 11, text: 'November' },
                { value: 12, text: 'December' }
            ],
            disbursement:{
                payroll_sheet:null,
                title: '',
                notes:'',
            }
        };
    },

    computed: {
        ...mapState({
            items: state => state.payroll.payroll_sheet,
            count: state => state.payroll.payroll_sheet_count,
            payrollLoading: state => state.payroll.payrollLoading,
            payrollError: state => state.payroll.payrollError
        })
    },

    mounted() {
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });

                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.fetchInitial();
            }
        }
    },

    watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/hr/payroll/payroll-list',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    },
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("payroll/fetchPayrollSheetList", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    search_term: this.filter
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/hr/payroll/payroll-list',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    },
                });
                this.perPage = newperPage
                this.$store.dispatch("payroll/fetchPayrollSheetList", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    search_term: this.filter
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        filter(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("payroll/fetchPayrollSheetList", {
                    perPage: this.perPage,
                    currentPage: 1,
                    search_term: this.filter
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },
    },

    methods: {
        fetchInitial() {
            this.$store.dispatch("payroll/fetchPayrollSheetList", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                search_term: this.filter
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        getStatusVariant(status) {
            if (!status) return 'secondary';

            switch (status) {
                case 'FINALIZED':
                    return 'success';
                case 'DRAFT':
                    return 'warning';
                case 'CLOSED':
                    return 'danger';
                default:
                    return 'primary';
            }
        },

        getMonthName(month) {
            const monthIndex = Number(month);
            const monthNames = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ];
            return monthNames[monthIndex - 1] || month;
        },

        finalisePayrollSheet(id) {
            this.finalise_id = id
        },

        handleFinaliseOk() {
            this.$store.dispatch("payroll/finalisePayrollSheet", {
                id: this.finalise_id,
                currentPage: this.$route.query.page,
                perPage: this.$route.query.perPage,
                search_term: this.filter
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.finalise_id = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        handleGeneratePayrollSheet() {
            this.$store.dispatch("payroll/generatePayrollSheet", {
                month: this.generate_month,
                year: this.generate_year,
                currentPage: this.$route.query.page,
                perPage: this.$route.query.perPage,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.generate_month = null
                    this.generate_year = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },
        createDisburse(data){
            this.disbursement.payroll_sheet = data.id
        },
        handleDisbursement(bvModalEvent){
            bvModalEvent.preventDefault()
            this.handleDisbursementSubmit()
        },
        handleDisbursementSubmit(){
            this.$store.dispatch("payroll/generateDisbursement", 
                {
                    disbursement: this.disbursement
                }
            ).then(response => {

                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.disbursement = {
                payroll_sheet:null,
                title: '',
                notes:'',
            }
            this.$nextTick(() => {
                this.$bvModal.hide('modal-disbursement-create')
            })
        }

    }
};
</script>

<style scoped>
.form-inside-container {
    display: flex;
    gap: 20px;
    width: 100%;
}

.header-width {
    width: 50%;
}

.item-padding {
    padding-left: 12px;
    padding-right: 12px;
}

.button-style {
    padding: 2px;
    width: 32px;
    font-size: larger;
    text-align: center;
    color: white;
    background-color: #222131;
    border-radius: 4px;
    cursor: pointer;
}

@media screen and (max-width: 991px) {
    .form-inside-container {
        display: flex;
        flex-direction: column;
        gap: 0px;
    }

    .header-width {
        width: 100%;
    }

    .item-padding {
        padding-left: 0px;
        padding-right: 0px;
    }
}
</style>
